import {
  FormControl,
  FormLabel,
  InputProps,
  Input as ChakraInput,
  FormErrorMessage,
  InputGroup,
  InputRightElement as ChakraInputRightElement,
  InputLeftElement as ChakraInputLeftElement,
  Flex,
} from '@chakra-ui/react';
import { forwardRef, ForwardRefRenderFunction } from 'react';
import { BsInfoCircle } from 'react-icons/bs';
import PopoverCustom from '../Generic/Popover';

export interface IProps extends InputProps {
  name: string;
  label?: string;
  error?: any;
  isRequired?: boolean;
  InputLeftElement?: any;
  InputRightElement?: any;
  activePopOver?: boolean;
  popOverIcon?: JSX.Element;
  popOverText?: string;
  popOverHeader?: string;
}

const Input: ForwardRefRenderFunction<HTMLInputElement, IProps> = (
  {
    label,
    name,
    error = null,
    isRequired,
    InputRightElement,
    InputLeftElement,
    mb,
    mt,
    activePopOver,
    popOverText,
    popOverHeader,
    ...rest
  },
  ref,
) => {
  return (
    <FormControl
      isInvalid={!!error}
      isRequired={isRequired}
      mb={mb}
      mt={mt}
      {...rest}
    >
      <Flex alignItems="center">
        {!!label && <FormLabel htmlFor={name}>{label}</FormLabel>}
        {activePopOver && (
          <PopoverCustom
            mb="2"
            icon={<BsInfoCircle />}
            headerText={popOverHeader}
          >
            {popOverText}
          </PopoverCustom>
        )}
      </Flex>
      <InputGroup>
        {!!InputLeftElement && (
          <ChakraInputLeftElement>{InputLeftElement}</ChakraInputLeftElement>
        )}
        <ChakraInput
          name={name}
          id={name}
          focusBorderColor="brand.500"
          bgColor="gray.200"
          backgroundColor="#FFFFFF"
          _placeholder={{ color: 'gray.500' }}
          variant="filled"
          w="100%"
          _hover={{ borderColor: 'brand.500' }}
          borderColor="gray.200"
          size="md"
          {...rest}
          ref={ref}
        />
        {!!InputRightElement && (
          <ChakraInputRightElement>{InputRightElement}</ChakraInputRightElement>
        )}
      </InputGroup>
      {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>}
    </FormControl>
  );
};

export default forwardRef(Input);
